
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class QRyStockcardDialog extends Serenity.EntityDialog<QRyStockcardRow, any> {
        protected getFormKey() { return QRyStockcardForm.formKey; }
        protected getIdProperty() { return QRyStockcardRow.idProperty; }
        protected getLocalTextPrefix() { return QRyStockcardRow.localTextPrefix; }
        protected getNameProperty() { return QRyStockcardRow.nameProperty; }
        protected getService() { return QRyStockcardService.baseUrl; }
        protected getDeletePermission() { return QRyStockcardRow.deletePermission; }
        protected getInsertPermission() { return QRyStockcardRow.insertPermission; }
        protected getUpdatePermission() { return QRyStockcardRow.updatePermission; }

        protected form = new QRyStockcardForm(this.idPrefix);

        constructor() {
            super();

            this.form.SumWhsFg.changeSelect2(e => {
                let Fg = Q.toId(this.form.SumWhsFg.value)
                if (Fg == 0) {
                    // this.form.ListFg.value = 1
                    Serenity.EditorUtils.setReadOnly(this.form.WhsFg, true);
                    Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);
                    this.form.WhsFg.value = null
                    this.form.WhsId.value = null
                    this.form.ShopId.value = null
                    
                }
                if (Fg == 1) {
                   
                    Serenity.EditorUtils.setReadOnly(this.form.WhsFg, false);
                    Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);
                    this.form.WhsFg.value = "0"
                    
                }
                
            });

            this.form.WhsFg.changeSelect2(e => {
                let Fg = Q.toId(this.form.WhsFg.value)
                if (Fg == 0) {
                                  
                    Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);                    
                    this.form.WhsId.value = null
                    this.form.ShopId.value = null
                    
                }
                if (Fg == 1) {                   
                   
                    Serenity.EditorUtils.setReadOnly(this.form.WhsId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);
                    // this.form.WhsId.value = null
                    this.form.ShopId.value = null
                    
                }
                if (Fg == 2) {                   
                   
                    Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShopId, false);
                    this.form.WhsId.value = null
                    // this.form.ShopId.value = null
                    
                }
                
            });
            
            this.form.ListFg.change(e => {
                let a = this.form.ListFg.value
                if (a == "1") {
                    // this.form.ListFg.value = 1
                    Serenity.EditorUtils.setReadOnly(this.form.SkuCode, false);
                    Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);
                    this.form.PluCode.value = null
                    
                }
                else{
                    // this.form.ListFg.value = 0
                    Serenity.EditorUtils.setReadOnly(this.form.SkuCode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.PluCode, false);
                    this.form.SkuCode.value = null
                }
            });

            this.form.PluCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.PluCode.value)
                var plu : string = this.form.PluCode.value
                if (Fg != null) {
                    // this.form.ListFg.value = 1
                    this.form.SkuCode.value = Product.CsPluRow.getLookup().itemById[plu].SkuCode
                }
                if (Fg = null) {
                    // this.form.ListFg.value = 0
                }
            });

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.push(
                {
                    title: Q.text(" Continue"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-report',
                    icon: 'fa fa-check text-green',
                    onClick: () => {
                        var s = this.whsfgcheck();
                        if(s){

                        }else{

                            // var options = this.getSaveOptions((response) => {

                                
                            //         var id1 = response.EntityId;
                            //         // if (id1 == null) {
                            //         //     id1 = this.get_entityId();
                            //         // }
                            //         // var a = this.loadById(id1);
                                  

                            //         if(this.form.SumWhsFg.value == "1"){
                            //             InventoryReport.IcReport07SkuWhsGrid.mypassvalue =id1
                            //             let url = '/InventoryReport/IcReport07SkuWhs';
                            //             window.location.href = url;
                            //         }
                            //         if(this.form.SumWhsFg.value == "0"){
                            //             InventoryReport.IcReport07SkuGrid.mypassvalue =id1
                            //             let url = '/InventoryReport/IcReport07Sku';
                            //             window.location.href = url;
                            //            }
                            //     // this.showSaveSuccessMessage(response);
                                

                            // });
                        this.save((response) => {
                            var id1 = response.EntityId;
                            // this.dialogClose();                       
                           if(this.form.SumWhsFg.value == "1"){
                            // InventoryReport.IcReport07SkuWhsGrid.mypassvalue =id1  //ไม่ได้
                            let url = '/InventoryReport/IcReport07SkuWhs';
                            window.location.href = url;
                           }
                           if(this.form.SumWhsFg.value == "0"){
                            // InventoryReport.IcReport07SkuGrid.mypassvalue =id1
                            let url = '/InventoryReport/IcReport07Sku';
                            window.location.href = url;
                           }
                            
                        });
                    }
                        
                       
                    },
                }
            );
            buttons.push(
                {
                    title: Q.text(""),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa fa-close text-red',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            Serenity.EditorUtils.setReadOnly(this.form.WhsFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);
            Serenity.EditorUtils.setReadOnly(this.form.SkuCode, false);
            Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);
            this.form.PostSequenceFg.value = Inventory.IcParaRow.getLookup().itemById[1].PostSequenceFg
            // this.form.DateEnd.value = 
       
            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }
       
                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            self.element.find(".panel-titlebar").html("StockCard Filter");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                             self.element.parent().find(".panel-titlebar").html("StockCard Filter");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                           // self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            
        }

        private whsfgcheck(){
            let sum = Q.toId(this.form.SumWhsFg.value)
            if(sum == 1){
                let ex = Q.toId(this.form.WhsFg.value)
                if(ex == 0){
                    return false
                }
                if(ex == 1){
                    let whs = Q.toId(this.form.WhsId.value)
                    if(whs == null){
                        Q.warning("โปรด ระบุคลังสินค้า");
                        return true
                    }else{
                        return false
                    }
                    
                }
                if(ex == 2){
                    let sp = Q.toId(this.form.ShopId.value)
                    if(sp == null){
                        Q.warning("โปรด ระบุร้านค้า");
                        return true
                    }else{
                        return false
                    }
                }

            }else{
                return false
            }
            
        }

    }
}